import React from "react";
import styles from "./ReactivateSubscription.module.css";
import { lockIcon } from "../../../utility-functions/assetLoader";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const ReactivateSubscription = ({ tabName = "" }) => {
  const navigate = useNavigate();
  const { canManageBillingSubscription } = useSelector(
    (state) => state?.auth?.permissions,
  );

  const handleReactivateClick = () => {
    navigate("/billing/cart", { state: { from: "reactivate" } });
  };

  return (
    <div className="screen-container">
      <div className={styles.container}>
        <div className={styles.iconCircle}>{lockIcon()}</div>
        <h2 className={styles.title}>Your subscription has ended</h2>
        <p className={styles.subtitle}>
          {canManageBillingSubscription
            ? `Reactivate to access ${tabName} and other features.`
            : `To access ${tabName} and other features, please contact your account admin.`}
        </p>
        {canManageBillingSubscription && (
          <button
            id="reactivate-subscription-btn"
            className={styles.reactivateButton}
            onClick={handleReactivateClick}
          >
            Reactivate
          </button>
        )}
      </div>
    </div>
  );
};

export default ReactivateSubscription;
